import { getTermValue } from '@/packages/JsonQuery';
import { EElectronicTradingType } from '@/packages/api-models/common/json_query';

import { type ITagGroupConfig } from '../types';

const TEXT_MAP: { [key in EElectronicTradingType]: string } = {
  [EElectronicTradingType.DoNotDisplay]: 'Не показывать торги и залоговую недвижимость',
  [EElectronicTradingType.ElectronicTradingOnly]: 'Только торги и залоговая недвижимость',
};

export const electronicTrading: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = getTermValue('electronic_trading')(jsonQuery);
    if (value == null) {
      return null;
    }

    return [
      {
        group: 'electronicTrading',
        text: TEXT_MAP[value],
      },
    ];
  },
  delete({ onChange }) {
    onChange({
      action: 'setElectronicTradingType',
      arguments: [null],
    });
  },
};
